import script from "./UploadBaselineDocument.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadBaselineDocument.vue?vue&type=script&setup=true&lang=js"

import "./UploadBaselineDocument.vue?vue&type=style&index=0&id=5d6e5d22&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d6e5d22"]])

export default __exports__